"use strict";
// Copyright (c) 2021-2024, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
const cdn_1 = require("../helpers/cdn");
($ => {
    const setup = () => {
        $.fn.isOverlayOpen = function () {
            return window.Overlay.isOpen($(this));
        };
        $.fn.overlay = function (action, options = {}) {
            return window.Overlay.handle($(this), action, options);
        };
        $.isOverlayOpen = () => {
            return $(document.body).isOverlayOpen();
        };
        $.overlay = (action, options = {}) => {
            return $(document.body).overlay(action, options);
        };
    };
    if (typeof window.Overlay === 'undefined') {
        $.getScript({
            url: `${cdn_1.JSDELIVR}/@gibme/overlay@${(0, cdn_1.version)('@gibme/overlay')}/dist/Overlay.min.js`,
            cache: true,
            success: () => setup()
        });
    }
    else {
        setup();
    }
})(window.$);
//# sourceMappingURL=overlay.js.map